import { render, staticRenderFns } from "./RemoveWorkOrdersFromInvoiceNewModal.vue?vue&type=template&id=71d76485&"
import script from "./RemoveWorkOrdersFromInvoiceNewModal.vue?vue&type=script&lang=js&"
export * from "./RemoveWorkOrdersFromInvoiceNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports